<div class="tabbable__body no-margin">
  <h2>Fakturor</h2>
  <br>
  <dot-loader [visibility]="!invoices" [large]="true"></dot-loader>

  @if (invoices) {
    <h3>Igår</h3>
    <app-woo-table [data]="invoices.yesterday" [noDataText]="'Det finns inga fakturor som skulle ha skickats igår.'">
      <woo-table-column name="campaign" header="Kampanj"></woo-table-column>
      <woo-table-column name="booked" header="Bokad">
        <ng-template let-cell>{{ cell.value | date : 'mediumDate' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="name" header="Faktura">
        <ng-template let-cell>{{ cell.value }}</ng-template>
      </woo-table-column>
      <woo-table-column name="gross" header="Brutto">
        <ng-template let-cell>{{ cell.value | currency : 'SEK' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="vat" header="Moms">
        <ng-template let-cell>{{ cell.value | currency : 'SEK' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="status" header="Skickad">
        <ng-template let-cell>{{ cell.value === InvoiceStatus.sent ? 'Ja' : 'Nej' }}
          @if (cell.value === InvoiceStatus.cancelled) {
            <span class="text-danger strong">Makulerad</span>
          }
        </ng-template>
      </woo-table-column>
    </app-woo-table>

    <h3>I&nbsp;morse</h3>
    <app-woo-table [data]="invoices.today" [noDataText]="'Det finns inga fakturor som skulle ha skickats i morse.'">
      <woo-table-column name="campaign" header="Kampanj"></woo-table-column>
      <woo-table-column name="booked" header="Bokad">
        <ng-template let-cell>{{ cell.value | date : 'mediumDate' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="name" header="Faktura">
        <ng-template let-cell>{{ cell.value }}</ng-template>
      </woo-table-column>
      <woo-table-column name="gross" header="Brutto">
        <ng-template let-cell>{{ cell.value | currency : 'SEK' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="vat" header="Moms">
        <ng-template let-cell>{{ cell.value | currency : 'SEK' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="status" header="Skickad">
        <ng-template let-cell>{{ cell.value === InvoiceStatus.sent ? 'Ja' : 'Nej' }}
          @if (cell.value === InvoiceStatus.cancelled) {
            <span class="text-danger strong">Makulerad</span>
          }
        </ng-template>
      </woo-table-column>
    </app-woo-table>
    

    <h3>Kommande</h3>
    <app-woo-table [data]="invoices.upcoming" [noDataText]="'Det finns inga fakturor som skulle ha skickats i morse.'">
      <woo-table-column name="campaign" header="Kampanj"></woo-table-column>
      <woo-table-column name="booked" header="Bokad"><ng-template let-cell>{{ cell.value | date : 'mediumDate' }}</ng-template></woo-table-column>
      <woo-table-column name="name" header="Faktura"><ng-template let-cell>{{ cell.value }}</ng-template></woo-table-column>
      <woo-table-column name="gross" header="Brutto"><ng-template let-cell>{{ cell.value | currency : 'SEK' }}</ng-template></woo-table-column>
      <woo-table-column name="vat" header="Moms"><ng-template let-cell>{{ cell.value | currency : 'SEK' }}</ng-template></woo-table-column>
      <woo-table-column name="date" header="Skickas"><ng-template let-cell>{{ cell.value | date : 'mediumDate' }}</ng-template></woo-table-column>
    </app-woo-table>
  }
</div>
